import { catchRestError, RestClient } from "clients/rest";
import { UseFormReturn } from "react-hook-form";
import { PageableResponse } from "../PageableResponse";

export type B000230FindRequest = Partial<{
  kengenIdFrom: string;
  kengenIdTo: string;
  name: string;
  page: number;
  sort: string[];
  size: number;
}>;

export type B000230FindResponse = {
  kengenId: string;
  kengenNm: string;
};

export const B000230Find = (props: B000230FindRequest) => {
  return RestClient.get<PageableResponse<B000230FindResponse[]>>(
    "b000230/find",
    {
      params: props,
    }
  );
};

export type B000230GetRequest = {
  kengenId: string;
};

export type B000230GetResponse = {
  kengenId: string;
  kengenNm: string;
};

export const B000230Get = (props: B000230GetRequest) => {
  return RestClient.get("b000230/get", {
    params: props,
  });
};

//利用権限名取得メソッド
export const B000230KengenNm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.kengenId === "") {
    methods.setValue("kengenNm", data.kengenId);
    return;
  }
  await B000230Get({ kengenId: data.kengenId })
    .then((response) => {
      methods.setValue("kengenNm", response.data.kengenNm ?? "");
    })
    .catch((reason) => {
      methods.setValue("kengenNm", "");
      catchRestError(reason, navigate, setMsg);
    });
};
